import React from 'react';

function People({ language = 'en' }) {
  const teamMembers = [
    {
      name: { en: 'DR MAHMOOD', ar: 'DR MAHMOOD' },
      description: {
        en: 'Mahmoud I. Abujobara, Managing Director of Al-Jabriyah Establishment, leads the company with a clear strategic vision focused on excellence, innovation, and sustainable growth. With strong expertise in commercial management and project development, he ensures the delivery of high-quality services across printing, logistics, marketing activations, and event operations. Under his leadership, Al-Jabriyah has earned a reputation for reliability, efficiency, and premium service execution. Mahmoud is dedicated to building long-term partnerships, improving operational performance, and empowering teams to deliver outstanding results that exceed client expectations.',
        ar: 'محمود أبوجبارة، المدير التنفيذي لمؤسسة الجبرية، يقود المؤسسة برؤية استراتيجية واضحة ترتكز على التميز، الابتكار، والنمو المستدام. بخبرته في الإدارة التجارية وتطوير المشاريع، يضمن تقديم خدمات عالية الجودة في مجالات الطباعة، اللوجستيات، التفعيل الميداني، وإدارة الفعاليات. نجحت الجبرية تحت قيادته في ترسيخ سمعتها كشريك موثوق يقدم حلولاً فعّالة وتنفيذًا احترافيًا. يركز محمود على بناء شراكات طويلة المدى، تطوير الأداء التشغيلي، وتمكين الفرق لتحقيق نتائج مميزة تتجاوز توقعات العملاء.'
      },
      image: '/img/mahmood.jpg'
    },
    {
      name: { en: 'DR MOHAMAD', ar: 'DR MOHAMAD' },
      description: {
        en: '“Al-Jabriyah continues to set a high benchmark in printing, logistics, and field activation services. Their ability to deliver precise execution, fast turnaround, and exceptional quality makes them a preferred partner for major brands in Saudi Arabia. The team demonstrates outstanding professionalism and attention to detail, ensuring that every project is completed with excellence and reliability. Their commitment to high standards consistently transforms ideas into powerful on-ground results.”',
        ar: '“تواصل مؤسسة الجبرية تقديم مستوى استثنائي في خدمات الطباعة، اللوجستيات، والتفعيل الميداني، لتضع معيارًا عاليًا في السوق السعودي. تمتاز الجبرية بسرعة التنفيذ، ودقة الإنجاز، وجودة لا تُجارى، مما يجعلها شريكًا مفضلًا لدى العديد من العلامات التجارية الكبرى. يتميز فريق العمل باحترافية عالية واهتمام دقيق بالتفاصيل، مما يضمن تنفيذ كل مشروع بأفضل صورة ممكنة. التزامهم بالتميز يحوّل الأفكار إلى نتائج ميدانية قوية وموثوقة.”'
      },
      image: '/img/mohamad.jpg'
    },
    {
      name: { en: 'DR HAITHAM', ar: 'DR HAITHAM' },
      description: {
        en: '“Al-Jabriyah is one of the best organizations we have worked with in the market. They demonstrate exceptional excellence in high-level work, deliver top-quality services, and have a professional, skilled, experienced, and highly committed team.”',
        ar: 'مؤسسة الجبرية من افضل من عملنا معهم في السوق… تميز في العمل رفيع المستوى، و خدمات ذات جودة عالية، و طاقم عمل يتميز بالاحترافية و المهارة و الخبرة و الالتزام.'
      },
      image: '/img/Picture20.png'
    },
    {
      name: { en: 'DR Haytham jouda', ar: 'DR Haytham jouda' },
      description: {
        en: 'I believe that the strength in our team and ability to deal with adversities is what makes us a great partner for our clients. THIS IS WHY I\'M PROUD TO BE ONE OF THIS TEAM. Al-jabriyah aims to become the leading business solution provider of IT Services in the region.',
        ar: 'أؤمن بأن قوة فريقنا وقدرتنا على التعامل مع التحديات هي ما يجعلنا شريكاً مميزاً لعملائنا. ولهذا أنا فخور بأنني أحد أعضاء هذا الفريق. تهدف الجابرية إلى أن تصبح المزود الرائد لحلول الأعمال وخدمات تقنية المعلومات في المنطقة.'
      },
      image: '/img/Haytham jouda.jpg'
    }
  ];

  return (
    <section className="people-section" id="people">
      <h2 className="people-title">
        {language === 'ar' ? 'الفريق ' : 'Executive '}
        <span>{language === 'ar' ? 'التنفيذي' : 'Team'}</span>
      </h2>

      <div className="people-grid">
        {teamMembers.map((member, index) => (
          <React.Fragment key={index}>
            <div className="person-box">
              <img src={member.image} className="person-img" alt={member.name[language]} />
              <div className="person-info">
                <h3>{member.name[language]}</h3>
                <p>{member.description[language]}</p>
              </div>
            </div>
            {index === 1 && <div className="divider"></div>}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

export default People;